import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "w-100 d-flex flex-row justify-content-between align-items-center" }
const _hoisted_2 = { class: "text-dark mb-0 flex-shrink-0" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "pi pi-pencil text-primary ml-2"
}
const _hoisted_5 = {
  key: 2,
  class: "pi pi-check-circle text-success ml-2"
}
const _hoisted_6 = ["id"]
const _hoisted_7 = { class: "w-100 d-flex flex-row justify-content-between align-items-center" }
const _hoisted_8 = { class: "mb-0 flex-shrink-0" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "px-3 pt-3 font-weight-bold text-muted" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", {
  class: "cil-location-pin mr-5",
  style: {"font-size":"40px"}
}, null, -1)
const _hoisted_12 = { class: "flex-grow-1" }
const _hoisted_13 = { class: "mb-1" }
const _hoisted_14 = { class: "mb-1" }
const _hoisted_15 = { class: "mb-1" }
const _hoisted_16 = { class: "mb-0" }
const _hoisted_17 = {
  key: 1,
  class: "ml-auto mb-0 text-primary",
  style: {"height":"40px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_FieldTemplate = _resolveComponent("FieldTemplate")!
  const _component_OrganizationCard = _resolveComponent("OrganizationCard")!
  const _component_PanelTemplate = _resolveComponent("PanelTemplate", true)!
  const _component_translate = _resolveComponent("translate")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Accordion, {
    class: _normalizeClass(["card flat", { 'bg-light': _ctx.panel?.displayType?.toLowerCase() === 'section', 'd-none': _ctx.panel?.hidden }]),
    "active-index": (_ctx.active || _ctx.$route.hash.startsWith('#' + _ctx.id)) ? 0 : -1,
    id: _ctx.id
  }, {
    default: _withCtx(() => [
      (_ctx.panel && (!_ctx.panel.repeatable || _ctx.panel.added))
        ? (_openBlock(), _createBlock(_component_AccordionTab, { key: 0 }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("h6", _hoisted_2, [
                  _createTextVNode(_toDisplayString(_ctx.panel.ordinal || ''), 1),
                  (_ctx.panel.ordinal)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_3, " "))
                    : _createCommentVNode("", true),
                  _createTextVNode(_toDisplayString(_ctx.label || _ctx.labelConditional) + " ", 1),
                  (_ctx.requiredIncomplete)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_4))
                    : _createCommentVNode("", true),
                  (_ctx.requiredComplete)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_5))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.canRemove)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      icon: "pi pi-trash",
                      class: "p-button-text border-primary",
                      label: _ctx.i18n.$gettext('Löschen'),
                      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('remove-content')), ["stop","prevent"]))
                    }, null, 8, ["label"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.children, (content, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: (_ctx.id || '') + '-' + content.contentId + '-' + i
                }, [
                  (content.contentType?.toLowerCase() === 'field' && _ctx.fieldVisible(content))
                    ? (_openBlock(), _createBlock(_component_FieldTemplate, {
                        key: 0,
                        id: (_ctx.id || '') + '-' + content.contentId + '-' + i,
                        ref_for: true,
                        ref: () => { if (content.repeatable && content.required && !content.added) { _ctx.addDefaultContent(i, content) } },
                        field: content,
                        project: _ctx.project,
                        index: i,
                        "can-remove": _ctx.canRemoveChild(content),
                        onRemoveContent: ($event: any) => (_ctx.panel.children.splice(i, 1)),
                        onValueChanged: _cache[1] || (_cache[1] = f => _ctx.$emit('value-changed', f)),
                        onCreateOrganization: _cache[2] || (_cache[2] = (contentId, organization) => _ctx.$emit('create-organization', contentId, organization)),
                        hidden: content.repeatable && !content.added
                      }, null, 8, ["id", "field", "project", "index", "can-remove", "onRemoveContent", "hidden"]))
                    : _createCommentVNode("", true),
                  (content.contentId === 'OPT-300-Procedure-Buyer' && _ctx.clientOrganization)
                    ? (_openBlock(), _createBlock(_component_OrganizationCard, {
                        key: 1,
                        organization: _ctx.clientOrganization,
                        header: !_ctx.project.templateId?.startsWith('EU-') ? (content.ordinal ? content.ordinal + ' ' : '') + _ctx.translateLabel(content) : undefined,
                        class: "card p-5 mt-4"
                      }, null, 8, ["organization", "header"]))
                    : (content.contentType?.toLowerCase() === 'group')
                      ? (_openBlock(), _createBlock(_component_PanelTemplate, {
                          key: 2,
                          id: (_ctx.id || '') + '-' + content.contentId + '-' + i,
                          ref_for: true,
                          ref: () => { if (content.repeatable && (content.required || _ctx.contentIsLot(content)) && !content.added) { _ctx.addDefaultContent(i, content) } },
                          panel: content,
                          project: _ctx.project,
                          index: i,
                          "repeatable-index": _ctx.childRepeatableIndex(content),
                          "can-remove": _ctx.canRemoveChild(content),
                          onRemoveContent: ($event: any) => (_ctx.panel.children.splice(i, 1)),
                          onValueChanged: _cache[3] || (_cache[3] = f => _ctx.$emit('value-changed', f)),
                          onCreateOrganization: _cache[4] || (_cache[4] = (contentId, organization) => _ctx.$emit('create-organization', contentId, organization)),
                          class: _normalizeClass({ 'd-none': content.repeatable && !content.added }),
                          onChooseProperty: _cache[5] || (_cache[5] = p => _ctx.$emit('choose-property', p))
                        }, null, 8, ["id", "panel", "project", "index", "repeatable-index", "can-remove", "onRemoveContent", "class"]))
                      : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: "w-100 d-flex flex-row justify-content-between align-items-center mb-3",
                    id: _ctx.id + '-copy-button'
                  }, [
                    (content.repeatable && !content.added && content.contentId !== 'BT-702(b)-notice')
                      ? (_openBlock(), _createBlock(_component_Button, {
                          key: 0,
                          class: "p-button-text bg-white flat mt-2",
                          icon: "pi pi-plus",
                          label: _ctx.translateLabel(content) + ' ' + _ctx.i18n.$gettext('hinzufügen'),
                          onClick: ($event: any) => (_ctx.panel.children.splice(i, 0, _ctx.copyPanel(content)))
                        }, null, 8, ["label", "onClick"]))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_6)
                ]))
              }), 128)),
              (_ctx.isLot)
                ? (_openBlock(), _createBlock(_component_Accordion, {
                    key: 0,
                    class: "card flat mb-4",
                    "active-index": 0
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_AccordionTab, null, {
                        header: _withCtx(() => [
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("h4", _hoisted_8, [
                              _createVNode(_component_translate, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Grundstücke")
                                ]),
                                _: 1
                              })
                            ]),
                            _createVNode(_component_Button, {
                              icon: "pi pi-plus",
                              class: "p-button-text border-primary",
                              label: _ctx.i18n.$gettext('Grundstück verknüpfen'),
                              onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.showPropertyChooserDialog = true), ["stop","prevent"]))
                            }, null, 8, ["label"])
                          ])
                        ]),
                        default: _withCtx(() => [
                          (!_ctx.linkedProperties.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                _createElementVNode("p", _hoisted_10, [
                                  _createVNode(_component_translate, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Keine Grundstücke verknüpft.")
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.linkedProperties, (property, i) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: property.id,
                              class: _normalizeClass(["w-100 p-3 mx-0 d-flex flex-row align-items-center", { 'list-row': i < _ctx.linkedProperties.length - 1 }])
                            }, [
                              _hoisted_11,
                              _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("p", _hoisted_13, _toDisplayString(property.location?.name || ''), 1),
                                _createElementVNode("h5", _hoisted_14, _toDisplayString(property.name), 1),
                                _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.sizeFormatted(property.size)) + ", " + _toDisplayString(property.plat), 1)
                              ]),
                              _createVNode(_component_Button, {
                                class: "p-button-text border-primary ml-auto",
                                icon: "pi pi-trash",
                                label: _ctx.i18n.$gettext('entfernen'),
                                onClick: ($event: any) => (_ctx.removeProperty(property))
                              }, null, 8, ["label", "onClick"])
                            ], 2))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.isLot)
                ? (_openBlock(), _createBlock(_component_Dialog, {
                    key: 1,
                    header: _ctx.i18n.$gettext('Grundstück auswählen'),
                    visible: _ctx.showPropertyChooserDialog,
                    "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.showPropertyChooserDialog) = $event)),
                    onHide: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showPropertyChooserDialog = false)),
                    modal: ""
                  }, {
                    footer: _withCtx(() => [
                      _createVNode(_component_Button, {
                        class: "p-button-text flat",
                        label: _ctx.i18n.$gettext('Schließen'),
                        autofocus: "",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showPropertyChooserDialog = false))
                      }, null, 8, ["label"])
                    ]),
                    default: _withCtx(() => [
                      (!_ctx.properties.data)
                        ? (_openBlock(), _createBlock(_component_ProgressBar, {
                            key: 0,
                            mode: "indeterminate"
                          }))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.properties.data || []).filter(p => p.isPublic && !p.isArchived), (property) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: property.id,
                          class: "d-flex flex-row align-items-center my-2"
                        }, [
                          _createElementVNode("h5", _hoisted_16, _toDisplayString(property.name), 1),
                          (!_ctx.project.propertyIds?.includes(property.id))
                            ? (_openBlock(), _createBlock(_component_Button, {
                                key: 0,
                                class: "ml-auto p-button-text bg-white border-primary flex-shrink-0",
                                icon: "pi pi-plus",
                                onClick: _withModifiers(($event: any) => (_ctx.addProperty(property)), ["stop","prevent"])
                              }, null, 8, ["onClick"]))
                            : (_openBlock(), _createElementBlock("p", _hoisted_17, [
                                _createVNode(_component_translate, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode("hinzugefügt")
                                  ]),
                                  _: 1
                                })
                              ]))
                        ]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["header", "visible"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["class", "active-index", "id"]))
}